module.exports = __webpack_public_path__ + "static/media/email-top-receivers.fa32da06.png";